require('./segment.js');
module.exports = 'ngSegment';



// WEBPACK FOOTER //
// ./node_modules/angular-segment-analytics/index.js